module.exports = __webpack_public_path__ + "img/portraits_15_H.f5576f62.jpg";